export default __webpack_public_path__ + "static/media/photo--lg--6.08040a5e.jpg";